export const SERVICE_LOADING="SERVICE_LOADING";
export const SERVICE_SUCCESS="SERVICE_SUCCESS";
export const SERVICE_ERROR="SERVICE_ERROR";